import { createContext } from "react";

export const AuthContext = createContext({
  isLoggedIn: false,
  userId: null,
  token: null,
  name: null,
  email: null,
  image: null,
  isadmin: false,
  isprojectmanager: false,
  isteammanager: false,
  uid: null,
  isAppInstalled: false,
  socket: null,
  workspaceId: null,
  breakstatus: null,
  latestTask: null,
  getUserLatestTask: () => {},
  seconds: 0,
  login: (
    isLoggedIn,
    userId,
    token,
    name,
    email,
    image,
    isadmin,
    isprojectmanager,
    uid,
    isAppInstalled,
    workspaceId,
    isteammanager
  ) => {},
  logout: () => {},
});
